/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import createTrack from 'services/actions/tracker_actions';
import {
  fmtBRL,
  fmtDataBR,
  fmtInt,
  LicitacaoAgrupada,
  SearchHit,
} from 'services/price_intelligence';
import PriceIntelligenceBiddingModal from 'components/molecules/price_intelligence_bidding_modal';
import { Container } from 'components/molecules/price_intelligence_sample_table/styles';

interface PriceIntelligenceBiddingTableProps {
  grupos: LicitacaoAgrupada[];
}

const PriceIntelligenceBiddingTable = ({ grupos }: PriceIntelligenceBiddingTableProps) => {
  const [aberta, setAberta] = useState<SearchHit | null>(null);

  const abrir = (grupo: LicitacaoAgrupada) => {
    createTrack('Análise de Preços - Abriu resultado da licitação', {
      licitacao_id: grupo.licitacaoId,
      origem: 'por_licitacao',
    });
    setAberta(grupo.itens[0]);
  };

  return (
    <Container>
      <table className="table">
        <thead>
          <tr>
            <th>Objeto</th>
            <th>Órgão / Local</th>
            <th>Vencedores</th>
            <th>Itens</th>
            <th style={{ textAlign: 'right' }}>Valor dos itens</th>
            <th>Data</th>
            <th aria-label="Detalhes" />
          </tr>
        </thead>
        <tbody>
          {grupos.map((g) => (
            <tr key={g.licitacaoId} className="selectable" onClick={() => abrir(g)}>
              <td className="desc-cell">
                <div className="desc-main" title={g.objeto || undefined}>
                  {g.objeto || '—'}
                </div>
                <div className="desc-extra">Nº ConLicitação {g.licitacaoId}</div>
              </td>
              <td className="org-cell">
                <div className="org-name" title={g.orgaoNome || undefined}>
                  {g.orgaoNome || '—'}
                </div>
                <div className="org-place">
                  {[g.municipio, g.uf].filter(Boolean).join('/') || '—'}
                </div>
              </td>
              <td className="supplier-cell">
                <span className="supplier-plain">{g.fornecedores[0] || '—'}</span>
                {g.fornecedores.length > 1 && (
                  <div className="desc-extra">
                    e mais {fmtInt(g.fornecedores.length - 1)}{' '}
                    {g.fornecedores.length === 2 ? 'vencedor' : 'vencedores'}
                  </div>
                )}
              </td>
              <td>{fmtInt(g.itens.length)}</td>
              <td className="value-cell">
                <span className="value-main">{g.total !== null ? fmtBRL(g.total) : '—'}</span>
              </td>
              <td className="date-cell">{fmtDataBR(g.data)}</td>
              <td className="link-cell">
                <button type="button" title="Resultado completo da licitação">
                  <i className="material-icons">visibility</i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <PriceIntelligenceBiddingModal hit={aberta} onClose={() => setAberta(null)} />
    </Container>
  );
};

export default PriceIntelligenceBiddingTable;
